import script from "./SearchFilters.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchFilters.vue?vue&type=script&setup=true&lang=ts"

import "./SearchFilters.vue?vue&type=style&index=0&id=47abd05a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47abd05a"]])

export default __exports__